/** The latest entry-window boundary or venue midnight, refreshed by each
 *  app's check-in sync. The day key labels the calendar; admission compares
 *  entry-window instants directly and does not depend on a calendar day. */
import { computed, state } from "@mhmo91/schmancy/state";
import { TicketType } from "@momo/types";
import { venueTimezone } from "../event/event.state.ts";

// A real boot reading also serves fixture-only mounts without a live clock.
export const todayInstant = state("scanner/today-instant").memory(Date.now(), {
	keepOnClear: true,
});

/** `YYYY-MM-DD` in the venue's own zone — a comparable, sortable key, never a
 *  rendering: TicketType.dayKeyOf's own contract, and the shape
 *  TicketType.daysCovered answers in, so the two compare directly. Display
 *  only: it names which day a surface is labelling, never which types a door
 *  admits. */
export const todayKey = computed(() =>
	TicketType.dayKeyOf(todayInstant.value, venueTimezone.value),
);
